import React from "react";
import { ControlProps } from "@jsonforms/core";
import { withJsonFormsControlProps } from "@jsonforms/react";

import { Options } from "./Options";

function OptionsControl({
  data,
  id,
  handleChange,
  path,
  label,
  required,
  visible,
  errors,
  rootSchema,
  uischema,
}: ControlProps): JSX.Element {
  const freeTextFields = Object.entries(rootSchema.properties ?? {})
    .filter(([, value]) => {
      return value.type === "string" && value.format === undefined && value.maxLength !== undefined;
    })
    .map(([key]) => key);

  // Set by forms built from a Paragon field mapping, whose install stores no config the service
  // could take the object from. Native forms leave it out.
  const entityName =
    typeof uischema.options?.entityName === "string" ? uischema.options.entityName : undefined;

  return (
    <Options
      id={id}
      value={data}
      label={label}
      required={required}
      disabled={!visible}
      updateValue={(value: string) => handleChange(path, value)}
      errors={errors}
      freeTextFields={freeTextFields}
      entityName={entityName}
    />
  );
}

export default withJsonFormsControlProps(OptionsControl);
